const StockType = [
    {id: "0", value: "普通股"},     
    {id: "1", value: "國內轉換公司債"},    
    {id: "2", value: "海外轉換公司債"},
    {id: "3", value: "特別股"},      
    {id: "4", value: "附認股權特別股"},  
  ];  
  
  export default StockType  